import {
  useSensor,
  useSensors,
  PointerSensor,
  DragEndEvent,
} from "@dnd-kit/core";

/**
 * Shared drag-and-drop wiring for `useFieldArray` lists.
 *
 * Returns the same `sensors` object plus a `handleDragEnd` handler that
 * looks up the dragged-from / dragged-to indexes from the field-array
 * `fields` ids and calls `move(from, to)`.
 *
 * This is byte-equivalent to the inline `useSensors(...)` + `handleDragEnd`
 * pair that existed in EstimateForm/EstimateFormMun/EstimateFormComparison.
 */
export function useFieldArrayDnd<T extends { id: string }>(
  fields: readonly T[],
  move: (from: number, to: number) => void,
) {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
  );

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = fields.findIndex((f) => f.id === active.id);
    const newIndex = fields.findIndex((f) => f.id === over.id);
    move(oldIndex, newIndex);
  };

  return { sensors, handleDragEnd };
}
